import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ParallaxImage = ({ 
  src, 
  alt, 
  className = "", 
  overlayGradient = true,
  speed = 0.5 
}) => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: false
  });

  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, speed * 100]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.div
        style={{ y }}
        className="w-full h-full"
      >
        <motion.img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          initial={{ scale: 1.2, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : { scale: 1.2, opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.6, 0.05, 0.01, 0.9] }}
        />
      </motion.div>
      
      {overlayGradient && (
        <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-transparent to-transparent opacity-60" />
      )}
    </div>
  );
};

export default ParallaxImage;
